import { apiRequest } from "../Component/Utils/ApiHundler";

const apiURL = process.env.REACT_APP_API_URL;

async function fetchModel(clientId, token) {
  const apiUrl = `${apiURL}/admin/model/list`;

  const body = clientId ? { ClientId: clientId } : {};

  const data = await apiRequest(apiUrl, {
    method: "POST",
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  return data?.message?.list || [];
}

export default fetchModel;